import React from 'react';

type BarVariant = 'accent' | 'success' | 'warn' | 'danger';

interface ProgressBarProps {
  value: number;
  max?: number;
  variant?: BarVariant;
  style?: React.CSSProperties;
}

export default function ProgressBar({ value, max = 100, variant = 'accent', style }: ProgressBarProps) {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div className="sk-bar" style={style}>
      <div className={`bar-fill ${variant}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
